// extracted by mini-css-extract-plugin
export default {"ViewClaimPage":"ViewClaimPage_ViewClaimPage__Azh7+","divider":"ViewClaimPage_divider__ONAF1","datepicker_fullWidth":"ViewClaimPage_datepicker_fullWidth__WBHTi"};